import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as AddIcon } from 'components/v2/Icons/svg/add.svg';
import { ReactComponent as MinimizeIcon } from 'components/v2/Icons/svg/minimize.svg';

const iconButtonSx = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: '8px',
  width: 32,
  height: 32,
};

const styles = {
  large: {
    label: { fontSize: '20px', lineHeight: 1.5, color: 'text.primary' },
    value: { minWidth: 48, textAlign: 'center', fontSize: '20px', lineHeight: 1.5, color: 'text.secondary' },
  },
  small: {
    label: { fontSize: '16px', lineHeight: 1.4, color: 'text.secondary' },
    value: { minWidth: 48, textAlign: 'center', fontSize: '16px', lineHeight: 1.4, color: 'text.secondary' },
  },
};

export default function TickerRow({ label, value, onChange, size = 'large' }) {
  const s = styles[size] || styles.large;
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ py: 1 }}>
      <Typography variant="body1" sx={s.label}>
        {label}
      </Typography>
      <Stack direction="row" alignItems="center" gap={0.25}>
        <IconButton size="small" aria-label={`Decrease ${label}`} onClick={() => onChange(value - 1)} sx={iconButtonSx}>
          <MinimizeIcon width={16} height={16} style={{ color: 'currentColor' }} />
        </IconButton>
        <Typography variant="body1" sx={s.value}>
          {value}
        </Typography>
        <IconButton size="small" aria-label={`Increase ${label}`} onClick={() => onChange(value + 1)} sx={iconButtonSx}>
          <AddIcon width={16} height={16} style={{ color: 'currentColor' }} />
        </IconButton>
      </Stack>
    </Stack>
  );
}
